import { BDEPermissions } from './BDEPermissions';
import { KAENCPermissions } from './KAENCPermissions';
import { KAERRPermissions } from './KAERRPermissions';
import { TSEPermissions } from './TSEPermissions';
export type Role = 'BDE' | 'KAENC' | 'KAERR' | 'TSE';

export interface IPermissionModel {
	name: string;
	route: string;
	components: string[];
}

export const RBAC_MODEL: Record<Role, IPermissionModel[]> = {
	BDE: BDEPermissions,
	KAENC: KAENCPermissions,
	KAERR: KAERRPermissions,
	TSE: TSEPermissions,
};
